(function ( $ ) {
  $.fn.multiStepForm = function(args) {
      if(args === null || typeof args !== 'object' || $.isArray(args))
        throw  " : Called with Invalid argument";
      var form = this;
      var tabs = form.find('.mrk-tab');
      var steps = form.find('.step');
      steps.each(function(i, e){
        $(e).on('click', function(ev){
          form.navigateTo(i);
        });
      });
      form.navigateTo = function (i) {
        tabs.removeClass('current').eq(i).addClass('current');
        form.find('.mrk-previous').toggle(i > 0);
        atTheEnd = i >= tabs.length - 1;
        form.find('.mrk-next').toggle(!atTheEnd);
        form.find('.mrk-submit-btn-wrapper').toggle(atTheEnd);
        fixStepIndicator(curIndex());
        if(curIndex() == 1){
          $('.mrk-popup-video').show().find('video').get(0).play();
        }
        return form;
      }
      function curIndex() {
        return tabs.index(tabs.filter('.current'));
      }
      function fixStepIndicator(n) {
        steps.each(function(i, e){
          i == n ? $(e).addClass('active') : $(e).removeClass('active');
        });
      }
      form.find('.mrk-previous').click(function() {
        form.navigateTo(curIndex() - 1);
      });
      form.find('.mrk-double-previous').click(function() {
        form.navigateTo(curIndex() - 2);
      });
      form.find('.mrk-cant-find-size').click(function() {
        form.navigateTo(curIndex() + 2);
      });

      form.find('.mrk-next').click(function() {
        if('validations' in args && typeof args.validations === 'object' && !$.isArray(args.validations)){
          if(!('noValidate' in args) || (typeof args.noValidate === 'boolean' && !args.noValidate)){
            form.validate(args.validations);
            if(form.valid() == true){
              form.navigateTo(curIndex() + 1);
              return true;
            }
            return false;
          }
        }
        form.navigateTo(curIndex() + 1);
      });
      form.find('.submit').on('click', function(e){
        if(typeof args.beforeSubmit !== 'undefined' && typeof args.beforeSubmit !== 'function')
          args.beforeSubmit(form, this);       
        if(typeof args.submit === 'undefined' || (typeof args.submit === 'boolean' && args.submit)){
          form.submit();
        }
        return form;
      });
      typeof args.defaultStep === 'number' ? form.navigateTo(args.defaultStep) : null;

      form.noValidate = function() {
        
      }
      return form;
  };
}(jQuery));
$(document).ready(function () {
  function initializeDigitalSizer() {
    var $sizer = $(".modal__content .mrk-popup-size-wrapper");
    if (!$sizer.length) return;

    $sizer.multiStepForm({
      defaultStep: 0
    });
    $sizer.find('[name="mrk-wig-size"]:eq(0)').prop('checked', true).trigger('change');
    $sizer.find('.card_resize_range').trigger('change');
  }

  // Stiletto 6 opens popups with its own internal event rather than the
  // old public `PopupOpened` event. Run after its modal has cloned the
  // sizer markup into the visible modal area.
  document.addEventListener('click', function (event) {
    if (!event.target.closest('[data-digital-sizer-trigger]')) return;
    window.setTimeout(initializeDigitalSizer, 0);
  }, true);

  if ($('.mrk-size-guide-page').length > 0) {
    initializeDigitalSizer();
  }
  const CARD_REAL_HEIGHT_MM = 53.98;
  let minDiameter = 7,
      maxDiameter = 14,
      pixelToMMRatio = 1;
  $(document).on("input change", ".card_resize_range", function () {
    updateCardCalibrationUI($(this));
  });
  function updateWigs(){
    console.log(pixelToMMRatio);
    $('.mrk-wig-item').each(function(){
      var height = Number($(this).attr('val')) * pixelToMMRatio;
      $(this).css('--height', `${height}px`)
    })
  }
  function updateCardCalibrationUI(input) {
    var $block = $(input).parents('.mrk-tab');
    let $cardSlider = $block.find(".card_resize_range");
    let $cardWrapper = $block.find(".card-image-wrapper");
    let $lines = $block.find(".card-image-wrapper .lines");

    let px = parseFloat($cardSlider.val());
    $cardWrapper.css("background-size", "auto " + px + "px");
    $lines.css("height", px + 4 + "px");
    pixelToMMRatio = px / CARD_REAL_HEIGHT_MM;
    updateWigs();
  }
  $(document).on("click", ".mrk-add-to-cart-btn", function () {
    $('[data-modal-close]').click();
    $('.product-form__cart-submit[name="add"]').click();
  });
  $(document).on("click", ".mrk-email-result-btn, .mrk-save-to-profile-btn", function () {
    $(this).parents('.mrk-form-inner-wrapper').find('.mrk-result-wrapper').stop(true, true).css('display', 'flex').hide().slideDown(200);
  });
  $(document).on("click", ".view-all-selected-size", function () {
    var selected_size = $('.modal__content .mrk-popup-size-wrapper [name="mrk-wig-size"]:checked').val();
    var url = `/collections/all?sort_by=title-ascending&filter.v.option.size=${selected_size}`
    location.href=url;
  });
  $(document).on("click", ".close-video-popup", function () {
    $(this).parents('.mrk-popup-video').hide().find('video').get(0).pause();
  });
  // Identify customer by email, save Size to profile, then track event (Klaviyo)
  $(document).on("click", ".mrk-save-data-klavyio", function (e) {
    e.preventDefault();

    var $btn = $(this);
    var $wrapper = $btn.closest('.mrk-result-wrapper');
    var email = ($wrapper.find('.mrk-email-input').val() || '').trim();
    var eventType = $wrapper.find('.mrk-email-input').attr('event-type') || 'Custom Event';

    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      alert('Please enter a valid email');
      return;
    }

    var originalHTML = $btn.html();
    $btn.html('<span class="loader"></span>').prop('disabled', true);

    // Grab selected size from modal radios
    var size = $btn.parents('.modal').find('[name="mrk-wig-size"]:checked').val() || null;

    window._learnq = window._learnq || [];

    // Identify (also saves custom profile property "Size")
    var identifyPayload = { '$email': email };
    if (size) identifyPayload['Size'] = size;
    _learnq.push(['identify', identifyPayload]);

    try { localStorage.setItem('kl_email', email); } catch(e){}
    if (size) { try { localStorage.setItem('kl_size', size); } catch(e){} }

    // Optional props: merge any JSON props from data attributes
    var props = {
      page: location.pathname,
      source: $btn.attr('id') || $btn.attr('name') || 'mrk-btn'
    };
    if (size) props.size = size;

    var propsJSON = $btn.attr('data-kl-props') || $wrapper.attr('data-kl-props');
    if (propsJSON) {
      try { Object.assign(props, JSON.parse(propsJSON)); } catch(e){}
    }

    // Track event
    _learnq.push(['track', eventType, props]);

    // UI feedback
    setTimeout(function () {
      $btn.html('Saved').prop('disabled', false);
    }, 400);
  });

  $(document).on("input change", ".card_resize_range", function () {
    updateCardCalibrationUI($(this));
  });
  $(document).on("input change", '[name="mrk-wig-size"]', function () {
    var value = $('[name="mrk-wig-size"]:checked').val();
    $(`[data-option-value="${value}"]`).click()
    $('.mrk-selected-size').html(value);
  });

  // Card resize increase
  $(document).on("click", ".card_resize_increase", function () {
    $(".card_calibration_page").each(function () {
      let $cardSlider = $(this).find(".card_resize_range");
      let step = parseFloat($cardSlider.attr("step")) || 1;
      let max = parseFloat($cardSlider.attr("max")) || 400;
      let val = parseFloat($cardSlider.val()) + step;
      if (val > max) val = max;
      $cardSlider.val(val).trigger("input");
    });
  });

  // Card resize decrease
  $(document).on("click", ".card_resize_decrease", function () {
    $(".card_calibration_page").each(function () {
      let $cardSlider = $(this).find(".card_resize_range");
      let step = parseFloat($cardSlider.attr("step")) || 1;
      let min = parseFloat($cardSlider.attr("min")) || 100;
      let val = parseFloat($cardSlider.val()) - step;
      if (val < min) val = min;
      $cardSlider.val(val).trigger("input");
    });
  });
});
